export class IDs {

    public static FLAG_ENABLE_LASTGANG = true;
    public static FLAG_ENABLE_SCOPE3 = true;

    public static MOD_CORE = 'core';
    public static MOD_LEGACY = 'legacy';
    public static MOD_ETOOL = 'etool';
    public static MOD_ETOOL_ADMIN = 'etool_admin';

    public static ENT_BACKUP_INFO = 'import_backup_info';
    public static ENT_IMPORT_DEFINITIONS = 'import_definitions';
    public static ENT_IMPORT_LOG = 'import_log';

    // LOCAL
    public static ENT_ALTERNATIVES_SYSTEM_TABELLE3 = 'alternatives_system_tabelle3';
    public static ENT_ANLAGEN_EIGENSTROM = 'anlagen_eigenstrom';
    public static ENT_ANLAGEN_EIGENSTROM_BIOMASSE = 'anlagen_eigenstrom_biomasse';
    public static ENT_ANLAGEN_EIGENSTROM_KWK = 'anlagen_eigenstrom_kwk';
    public static ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK = 'anlagen_eigenstrom_photovoltaik';
    public static ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE = 'anlagen_eigenstrom_solarthermie';
    public static ENT_ANLAGEN_EIGENSTROM_TYPEN = 'anlagen_eigenstrom_typen';
    public static ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN = 'anlagen_eigenstrom_waermepumpen';
    public static ENT_ANLAGEN_EIGENSTROM_WINDKRAFT = 'anlagen_eigenstrom_windkraft';
    public static ENT_ARCHIV_ITEMS = 'archiv_items';
    public static ENT_BETRIEBSDATEN = 'betriebsdaten';
    public static ENT_BUNDESLAND = 'bundesland';
    public static ENT_CO2_FAKTOREN = 'co2_faktoren';
    public static ENT_CO2_SCOPE3_ABFALL = 'co2_scope3_abfall';
    public static ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN = 'co2_scope3_angemietete_sachanlagen';
    public static ENT_CO2_SCOPE3_EMITTENTEN = 'co2_scope3_emittenten';
    public static ENT_CO2_SCOPE3_FRANCHISE = 'co2_scope3_franchise';
    public static ENT_CO2_SCOPE3_GUETER_EINKAUF = 'co2_scope3_gueter_einkauf';
    public static ENT_CO2_SCOPE3_GUETER_KAPITAL = 'co2_scope3_gueter_kapital';
    public static ENT_CO2_SCOPE3_INVESTITION = 'co2_scope3_investition';
    public static ENT_CO2_SCOPE3_PENDELN = 'co2_scope3_pendeln';
    public static ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS = 'co2_scope3_produkte_lebenszyklus';
    public static ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG = 'co2_scope3_produkte_nutzung';
    public static ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG = 'co2_scope3_produkte_verarbeitung';
    public static ENT_CO2_SCOPE3_REISEN = 'co2_scope3_reisen';
    public static ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT = 'co2_scope3_transport_nachgelagert';
    public static ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT = 'co2_scope3_transport_vorgelagert';
    public static ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN = 'co2_scope3_vermietete_sachanlagen';
    public static ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN = 'co2_scope3_vermietete_sachanlagen_raeumlichkeiten';
    public static ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE = 'co2_scope3_vermietete_sachanlagen_fahrzeuge';
    public static ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK = 'co2_scope3_vermietete_sachanlagen_technik';
    public static ENT_CO2_SCOPE3_LIEFERANT = 'co2_scope3_lieferanten';
    public static ENT_CO2_SCOPE3_PENDELN_KAMPAGNE = 'co2_scope3_pendeln_kampagne';
    public static ENT_DATEIABLAGE_DYNAMISCH = 'dateiablage_dynamisch';
    public static ENT_EINZELMASSNAHMEN = 'einzelmassnahmen';
    public static ENT_ENERGIEDATEN_EIGENSTROM = 'energiedaten_eigenstrom';
    public static ENT_ENERGIEDATEN_EIGENWAERME = 'energiedaten_eigenwaerme';
    public static ENT_ENERGIEDATEN_KRAFTSTOFFE = 'energiedaten_kraftstoffe';
    public static ENT_ENERGIEDATEN_KRAFTSTOFF_EINHEITEN = 'energiedaten_kraftstoff_einheiten';
    public static ENT_ENERGIEDATEN_KRAFTSTOFF_ENERGIETRAEGER = 'energiedaten_kraftstoff_energietraeger';
    public static ENT_ENERGIEDATEN_STROM = 'energiedaten_strom';
    public static ENT_ENERGIEDATEN_WAERME = 'energiedaten_waerme';
    public static ENT_ENERGIEDATEN_WAERME_EINHEITEN = 'energiedaten_waerme_einheiten';
    public static ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER = 'energiedaten_waerme_energietraeger';
    public static ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER_HEIZUNG_ELEKTRISCH = 'energiedaten_waerme_heizung_elektrisch';
    public static ENT_ENERGIEDATEN_WAERME_VERBRAEUCHE = 'energiedaten_waerme_verbraeuche';
    public static ENT_ENERGIEDATEN_WASSER = 'energiedaten_wasser';
    public static ENT_ENERGIEDATEN_WASSER_EINHEITEN = 'energiedaten_wasser_einheiten';
    public static ENT_ENERGIEKOSTEN_PROJEKTION = 'energiekosten_projektion';
    public static ENT_ENERGIE_COCKPIT_HINWEISE = 'energie_cockpit_hinweise';
    public static ENT_FAHRZEUGE = 'fahrzeuge';
    public static ENT_FAHRZEUGE_JAHRESWERTE = 'fahrzeuge_jahreswerte';
    public static ENT_FOERDERUNG = 'foerderung';
    public static ENT_PARTNER = 'partner';
    public static ENT_GALLERY = 'gallery';
    public static ENT_GEBAEUDE = 'gebaeude';
    public static ENT_GEBAEUDE_SANIERUNG = 'gebaeude_sanierung';
    // Das Gewerk steht nun in den Unternehmensdaten!
    // public static ENT_GEWERKE = 'gewerke';
    public static ENT_KENNZAHLEN_DYNAMISCH = 'kennzahlen_dynamisch';
    public static ENT_KENNZAHLEN_WERTE = 'kennzahlen_werte';
    public static ENT_KENNZAHLEN_IMPORT = 'kennzahlen_import';
    public static ENT_KONFIGURATION = 'konfiguration';
    public static ENT_LASTGANG = 'lastgang';
    public static ENT_MASCHINEN = 'maschinen';
    public static ENT_MASCHINEN_JAHRESWERTE = 'maschinen_jahreswerte';
    public static ENT_MASCHINEN_TYPEN = 'maschinen_typen';
    public static ENT_MASSNAHMEN = 'massnahmen';
    public static ENT_NACE_CODES = 'nace_codes';
    public static ENT_PV_EINGABE = 'pv_eingabe';
    public static ENT_REPORT = 'report';
    public static ENT_SONSTIGE_DATEN = 'sonstige_daten';
    public static ENT_STANDORT = 'standort';
    public static ENT_STANDORT_GRUPPE = 'standort_gruppe';
    public static ENT_STANDORT_ENERGIETRAEGER = 'standort_energietraeger';
    public static ENT_UNTERNEHMENSDATEN = 'unternehmensdaten';
    public static ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN = 'unternehmensdaten_tochtergesellschaften';
    public static ENT_WEITERE_GEWERKE = 'weitere_gewerke';
    public static ENT_ZAEHLER = 'zaehler';
    public static ENT_ZAEHLER_MEDIUM = 'zaehler_medium';
    public static ENT_ZAEHLERSTAND = 'zaehlerstand';
    public static ENT_ZERTIFIZIERUNGSOPTIONEN = 'zertifizierungsoptionen';
    public static ENT_ZUSTAENDIGKEITEN = 'zustaendigkeiten';

    public static ENT_EIGENE_RAEUMLICHKEITEN = 'eigene_raeumlichkeiten';
    public static ENT_ANGEMIETETE_RAEUMLICHKEITEN = 'angemietete_raeumlichkeiten';
    public static ENT_ANGEMIETETE_FAHRZEUGE = 'angemietete_fahrzeuge';

    public static ENT_OEL_ZAEHLERABLESUNG = 'oel_zaehlerablesung';
    public static ENT_OEL_ABRECHNUNG = 'oel_abrechnung';

    public static ENT_POPUP_BLOCK = 'popup_block';
    public static ENT_DATENCHECK = 'datencheck';

    public static ENT_ANABREISE = 'co2_scope3_anreise_kampagne';

    public static ENT_ENERGIEDATEN_AUSWAHL = 'energiedaten_auswahl';
    public static ENT_VSME_AUSWAHL = 'vsme_auswahl';
    public static ENT_VSME_EXPORT = 'vsme_export';
    public static ENT_VSME_REPORT = 'vsme_report';

    public static ENT_CUSTOM_DATENSATZ_REIHENFOLGE = 'custom_datensatz_reihenfolge';
    public static ENT_CUSTOM_ROW_NAME = 'custom_row_name';

    // CFM
    public static ENT_CFM_MOTIVATION = 'cfm_motivation';

    // VSME Basismodul
    public static ENT_VSME_B1 = 'vsme_b1';
    public static ENT_VSME_B2 = 'vsme_b2';
    public static ENT_VSME_B3 = 'vsme_b3';
    public static ENT_VSME_B4 = 'vsme_b4';
    public static ENT_VSME_B5 = 'vsme_b5';
    public static ENT_VSME_B6 = 'vsme_b6';
    public static ENT_VSME_B7 = 'vsme_b7';
    public static ENT_VSME_B8 = 'vsme_b8';
    public static ENT_VSME_B9 = 'vsme_b9';
    public static ENT_VSME_B10 = 'vsme_b10';
    public static ENT_VSME_B11 = 'vsme_b11';
    public static ENT_VSME_B12 = 'vsme_b12';

    // VSME BPM-Modul
    public static ENT_VSME_BPM1 = 'vsme_bp1';
    public static ENT_VSME_BPM2 = 'vsme_bp2';
    public static ENT_VSME_BPM3 = 'vsme_bp3';
    public static ENT_VSME_BPM3_SCOPE1 = 'vsme_bp3_scope1';
    public static ENT_VSME_BPM3_SCOPE2 = 'vsme_bp3_scope2';
    public static ENT_VSME_BPM4 = 'vsme_bp4';
    public static ENT_VSME_BPM5 = 'vsme_bp5';
    public static ENT_VSME_BPM5_C = 'vsme_bp5_c';
    public static ENT_VSME_BPM5_E = 'vsme_bp5_e';
    public static ENT_VSME_BPM6 = 'vsme_bp6';
    public static ENT_VSME_BPM7 = 'vsme_bp7';
    public static ENT_VSME_BPM8 = 'vsme_bp8';
    public static ENT_VSME_BPM9 = 'vsme_bp9';
    public static ENT_VSME_BPM10 = 'vsme_bp10';
    public static ENT_VSME_BPM11 = 'vsme_bp11';

    // VSME PAT-Modul
    public static ENT_VSME_N1 = 'vsme_n1';
    public static ENT_VSME_N2 = 'vsme_n2';
    public static ENT_VSME_N3 = 'vsme_n3';
    public static ENT_VSME_N4 = 'vsme_n4';
    public static ENT_VSME_N5 = 'vsme_n5';

    // EED
    public static ENT_EED_UMFRAGE = 'eed_umfrage';

    // NOINIT
    public static ENT_ALTERNATIVES_SYSTEM_TABELLE1 = 'alternatives_system_tabelle1';
    public static ENT_ALTERNATIVES_SYSTEM_TABELLE2 = 'alternatives_system_tabelle2';
    public static ENT_KENNZIFFERN_GENERATED = 'kennziffern_struct_generated';
    public static ENT_WITTERUNGSFAKTOREN = 'witterungsfaktoren';
    public static ENT_WITTERUNGSFAKTOREN_STANDORT = 'witterungsfaktoren_standort';

    // ADMIN
    public static ENT_USER = 'entity_user';
    public static ENT_USER_LOGIN = 'user_login';
    public static ENT_GROUP_ITEMS = 'group_items';
    public static ENT_REGISTRIERUNG = 'registrierung';
    public static ENT_MANDANTEN_USER = 'mandanten_user';
    public static ENT_SCHULUNG_REGISTRIERUNG = 'schulung_registrierung';
    public static ENT_KONTAKTE = 'kontakte';
    public static ENT_UNTERNEHMEN = 'unternehmen';
    public static ENT_BRANCHEN = 'branchen';
    public static ENT_BRANCHEN_BEREICHE = 'branchen_bereiche';
    public static ENT_BRANCHEN_GEWERKE = 'branchen_gewerke';
    public static ENT_DATEIEN = 'dateien';
    public static ENT_MEDIEN = 'medien';
    public static ENT_EEG_VERGUETUNG = 'eeg_verguetung';
    public static ENT_ERZEUGUNGS_LASTDATEN = 'erzeugungs_lastdaten';
    public static ENT_FOERDERUNG_ZUORDNUNG = 'foerderung_zuordnung';
    public static ENT_PARTNER_ZUORDNUNG = 'partner_zuordnung';
    public static ENT_GEWERKE_WZ = 'gewerke_wz';
    public static ENT_GEWERKE_GRUPPE = 'gewerke_gruppe';
    public static ENT_FAQ = 'faq';
    public static ENT_GLOSSAR = 'glossar';
    public static ENT_GLOSSAR_ZUORDNUNG = 'glossar_zuordnung';
    public static ENT_AKTUELLE_NACHRICHTEN = 'aktuelle_nachrichten';
    public static ENT_AKTUELLE_TERMINE = 'aktuelle_termine';
    public static ENT_EXTERNAL_ACCESS = 'external_access';
    public static ENT_MEHRSPRACHIGKEIT = 'mehrsprachigkeit';

    public static ENT_GTZ = 'gtz';
    public static ENT_GTZ_ORTE = 'gtz_orte';
    public static ENT_GTZ_STANDORT = 'gtz_standort';
    public static ENT_KENNZAHLEN_DEFINTION = 'kennzahlen_definition';
    public static ENT_KENNZAHLEN_WERTE_AGGREGATION = 'kennzahlen_aggregation';
    public static ENT_KENNZAHLEN_WERTE_ZENTRAL = 'kennzahlen_werte';
    public static ENT_NACE = 'nace';
    // OBSOLETE public static ENT_PARAMETER_EMISSIONSFAKTOREN = 'parameter_emissionsfaktoren';
    public static ENT_PARAMETER_ENERGIESTEUER = 'parameter_energiesteuer';
    public static ENT_PARAMETER_HEIZWERTE = 'parameter_heizwerte';
    public static ENT_PV_PARAMETER = 'pv_parameter';
    public static ENT_QUELLEN = 'quellen';
    public static ENT_SYSTEMPARAMETER = 'systemparameter';
    public static ENT_PLAUSIBILISIERUNG = 'plausibilisierung';
    public static ENT_SYSTEMTEXTE = 'systemtexte';
    public static ENT_SYSTEMTEXTE_ZUORDNUNG = 'systemtexte_zuordnung';
    public static ENT_BERATER = 'berater';
    public static ENT_BERATER_BEREICHE = 'berater_bereiche';
    public static ENT_BERATERZUORDNUNG = 'beraterzuordnung';
    public static ENT_VERBAND = 'verband';
    public static ENT_VERBAND_ZUORDNUNG = 'verband_zuordnung';
    public static ENT_ZERTIFIZIERUNG_ZUORDNUNG = 'zertifizierung_zuordnung';
    public static ENT_HWK = 'hwk';
    public static ENT_MAIL = 'mail';
    public static ENT_KONTAKT = 'kontakt';
    public static ENT_KONTAKT_FAQ = 'kontakt_faq';
    public static ENT_KONTAKT_FAQ_ZUORDNUNG = 'kontakt_faq_zuordnung';
    public static ENT_KONTAKT_THEMEN = 'kontakt_themen';
    public static ENT_VERSIONSHISTORIE = 'versionshistorie';

    public static ENT_KLIMAGASE = 'klimagase';
    public static ENT_KLIMAGASE_BENUTZER = 'klimagase_benutzer';
    public static ENT_KLIMAGASE_ART = 'klimagase_art';

    public static ENT_CO2_FAKTOREN_KLIMAGASE = 'co2_faktoren_klimagase';
    public static ENT_CO2_FAKTOREN_INTERN = 'co2_faktoren_intern';
    public static ENT_CO2_SICHERHEITSZUSCHLAG = 'co2_sicherheitszuschlag';
    public static ENT_CO2_SCOPE3_AUSWAHL = 'co2_scope3_auswahl';
    public static ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE = 'co2_faktoren_scope3_abfall';
    public static ENT_CO2_SCOPE3_FAKTOREN_MATERIAL = 'co2_faktoren_scope3_material';
    public static ENT_CO2_SCOPE3_FAKTOREN_GUETER = 'co2_faktoren_scope3_kapitalgueter';
    public static ENT_CO2_SCOPE3_FAKTOREN_PENDELN = 'co2_faktoren_scope3_pendeln';
    public static ENT_CO2_SCOPE3_FAKTOREN_REISEN_ENTFERNUNG = 'co2_faktoren_scope3_reisen_entfernung';
    public static ENT_CO2_SCOPE3_FAKTOREN_REISEN_UEBERNACHTUNG = 'co2_faktoren_scope3_reisen_uebernachtung';
    public static ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT = 'co2_faktoren_scope3_transport';
    public static ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT_UNTERKUNFT = 'co2_faktoren_scope3_transport_unterkunft';
    public static ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_RAEUMLICHKEITEN = 'co2_faktoren_angemietete_raeumlichkeiten';
    public static ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_FAHRZEUGE = 'co2_faktoren_angemietete_fahrzeuge';

    public static HINWEISE = 'hinweise';
    public static CO2_MEHRKOSTEN = 'co2_mehrkosten';
    public static KENNZIFFERN_BERECHNET = 'kennziffern_berechnet';
    public static KENNZIFFERN_BERECHNET_STANDORT = 'kennziffern_standort_berechnet';
    public static KENNZIFFERN_STRUKTURIERT = 'kennziffern_strukturiert';
    public static STEUER_ENERGIE = 'steuer_energie';
    public static STEUER_STROM = 'steuer_strom';
    public static CO2_FUSSABDRUCK_DETAIL = 'co2_fussabdruck_detail';
    public static CO2_FUSSABDRUCK_KENNZAHLEN = 'co2_fussabdruck_kennzahlen';

    public static ENT_ONLINE_HILFE = 'online_hilfe';

    public static SYSINFO_UNGUELTIGE_FAKTOREN = 'SYSINFO_UNGUELTIGE_FAKTOREN';

    // Context Keys
    public static CONTEXT_KEYS = {
        AssistentConfigBpm3Dialog: 'assistentConfigBpm3.dialog'
    };
}
